import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll'; // For smooth scrolling on the homepage

function Navbar() {
  const [showNav, setShowNav] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // This function scrolls the homepage to the top
  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setShowNav(true);
    } else {
      setShowNav(false);
    }
  };

  useEffect(() => {
    // Only add the scroll listener if we are on the homepage
    if (isHomePage) {
      window.addEventListener('scroll', handleScroll);
      // Set initial state based on scroll position
      handleScroll();
    } else {
      // On other pages, always show the nav
      setShowNav(true);
    }
    
    // Cleanup function
    return () => {
      if (isHomePage) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isHomePage]); // Re-run this effect if the page changes

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 p-4 bg-white/80 backdrop-blur-md shadow-md transition-transform duration-300 ${
        (isHomePage && !showNav) ? '-translate-y-full' : 'translate-y-0'
      }`}
    >
      <div className="container mx-auto flex justify-between items-center">
        
        {/* Smart Logo Link:
            - If on homepage, it's a button that scrolls to top.
            - If on another page, it's a link that opens homepage in new tab.
        */}
        {isHomePage ? (
          <button 
            onClick={scrollToTop} 
            className="text-2xl font-bold text-gray-800"
          >
            Techpack Creators
          </button>
        ) : (
          <a 
            href="/" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl font-bold text-gray-800"
          >
            Techpack Creators
          </a>
        )}

        <div className="space-x-4">
          {/* External Links (New Tab) */}
          <a href="/services" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600">
            Services
          </a>
          <a href="/portfolio" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600">
            Portfolio
          </a>
          <a href="/blog" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600">
            Blog
          </a>
          
          {/* --- THIS IS THE FINAL "SMART" CONTACT BUTTON --- */}
          {isHomePage ? (
            // If on homepage, use ScrollLink to scroll down
            <ScrollLink
              to="contact" // This is the ID of the contact form on your HomePage
              smooth={true}
              duration={800}
              className="px-4 py-2 bg-yellow-800 text-white rounded-lg hover:bg-yellow-900 cursor-pointer"
            >
              Contact
            </ScrollLink>
          ) : (
            // If on any other page, use a standard <a> tag to open /contact in a new tab
            <a
              href="/contact"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-yellow-800 text-white rounded-lg hover:bg-yellow-900 cursor-pointer"
            >
              Contact
            </a>
          )}
          {/* --- END OF "SMART" BUTTON --- */}
          
        </div>
      </div>
    </nav>
  );
}

export default Navbar;